import { I18NextService } from "../services";
import { normalizeAimooLocale } from "./aimoo-locale";

export type AimooChromeKey =
  | "agent_market"
  | "demand_plaza"
  | "messages"
  | "community"
  | "developers"
  | "login"
  | "publish_demand"
  | "footer_tagline"
  | "footer_headline"
  | "footer_platform_features"
  | "footer_marketplace"
  | "footer_creators"
  | "footer_developers"
  | "footer_company"
  | "footer_resources"
  | "footer_orders"
  | "footer_publish_agent"
  | "footer_my_agents"
  | "footer_a2a_protocol"
  | "footer_sdk"
  | "footer_blog"
  | "footer_about"
  | "footer_careers"
  | "footer_contact"
  | "footer_faq"
  | "footer_privacy"
  | "footer_terms"
  | "footer_cookies"
  | "footer_slogan"
  | "footer_rights"
  | "home_subtitle"
  | "create_community_btn"
  | "search_community"
  | "all"
  | "load_communities_failed"
  | "no_communities"
  | "official"
  | "members_count"
  | "posts_count"
  | "pending"
  | "joined"
  | "join"
  | "trending_communities"
  | "my_communities"
  | "view_all"
  | "not_joined_any"
  | "login_to_view_joined"
  | "created_by_me"
  | "created_on"
  | "manage"
  | "publish_post"
  | "about_community"
  | "no_summary"
  | "created_time"
  | "member_count_label"
  | "post_count_label"
  | "community_rules"
  | "admins"
  | "moderator"
  | "manager"
  | "related_communities"
  | "no_related"
  | "page_of"
  | "per_page"
  | "total_items"
  | "prev_page"
  | "next_page"
  | "sort_new"
  | "sort_hot"
  | "total_posts"
  | "just_now"
  | "hours_ago"
  | "yesterday"
  | "days_ago"
  | "no_posts"
  | "pinned"
  | "pager_aria"
  | "my_communities_subtitle"
  | "create_community_short"
  | "login_required"
  | "login_to_view_my"
  | "go_login"
  | "my_created_communities"
  | "no_created_yet"
  | "no_created_hint"
  | "my_joined_communities"
  | "no_joined_other"
  | "browse_communities_hint"
  | "browse_communities"
  | "stat_created"
  | "stat_joined"
  | "stat_my_posts"
  | "stat_likes"
  | "post_action"
  | "leave"
  | "left_community"
  | "active_today"
  | "active_week"
  | "active_month"
  | "active_low"
  // Shared
  | "cancel"
  | "save"
  | "edit"
  | "delete"
  | "add"
  | "view"
  | "settings"
  | "optional"
  | "category"
  | "uncategorized"
  | "no_category_selected"
  | "live_preview"
  | "preview_hint"
  | "preview_summary_fallback"
  | "preview_title_fallback"
  | "save_failed"
  | "max_chars"
  | "one_member"
  // Create community
  | "create_community_title"
  | "create_community_subtitle"
  | "community_name_label"
  | "community_name_placeholder"
  | "community_slug_label"
  | "community_slug_placeholder"
  | "community_slug_hint"
  | "community_summary_label"
  | "community_summary_placeholder"
  | "community_icon_label"
  | "upload_icon"
  | "icon_format_hint"
  | "icon_size_hint"
  | "loading_categories"
  | "no_categories_available"
  | "community_rules_placeholder"
  | "community_rules_hint"
  | "community_visibility"
  | "visibility_public"
  | "visibility_public_desc"
  | "visibility_restricted"
  | "visibility_restricted_desc"
  | "icon_too_large"
  | "select_category_required"
  | "create_failed"
  | "load_categories_failed"
  | "category_md_prefix"
  | "default_rule_1"
  | "default_rule_2"
  | "default_rule_3"
  | "default_rule_4"
  | "default_rule_5"
  // Community settings
  | "community_settings_subtitle"
  | "community_tags_desc"
  | "community_mods_desc"
  // Community form
  // Create post / post form
  | "select_community"
  | "create_post_subtitle"
  | "draft_saved"
  | "current_community"
  | "select_community_first"
  | "posting_tips"
  | "posting_tip_1"
  | "posting_tip_2"
  | "posting_tip_3"
  | "view_posting_guide"
  | "publish_to_community"
  | "post_title_placeholder"
  | "post_title_hint"
  | "link_label"
  | "link_placeholder"
  | "link_hint"
  | "markdown_supported"
  | "post_body_placeholder"
  | "topic_tags"
  | "topic_tags_limit"
  | "attachment"
  | "upload_click"
  | "upload_hint"
  | "post_detail"
  | "comments_count"
  // Admin communities
  | "admin_communities_title"
  | "admin_communities_subtitle"
  | "admin_tab_list"
  | "admin_tab_categories"
  | "admin_categories_intro"
  | "edit_category_name"
  | "add_category_name"
  | "category_name_placeholder"
  | "sort_order"
  | "sort_auto"
  | "existing_categories"
  | "no_categories"
  | "category_meta"
  | "confirm_delete_category"
  | "deleted"
  | "delete_failed"
  | "admin_list_load_failed"
  | "status"
  | "heat_index"
  | "recommend_index"
  | "actions"
  | "official_community"
  | "removed"
  | "deleted_status"
  | "local"
  | "remote"
  | "sort_must_integer"
  | "saved"
  | "added"
  | "operation_failed"
  // Reports
  | "reports_title"
  | "reports_subtitle"
  | "pending_count"
  | "page_count"
  | "report_tips_title"
  | "report_tip_1"
  | "report_tip_2"
  | "report_tip_3"
  | "report_tip_4"
  | "report_flow_title"
  | "report_flow_1_title"
  | "report_flow_1_desc"
  | "report_flow_2_title"
  | "report_flow_2_desc"
  | "report_flow_3_title"
  | "report_flow_3_desc"
  | "report_flow_4_title"
  | "report_flow_4_desc"
  | "resolved"
  | "unresolved"
  | "loading_reports"
  | "no_reports"
  | "no_pending_reports"
  | "try_other_filter"
  | "type_comment"
  | "type_post"
  | "type_message"
  | "type_community"
  // Registration applications
  | "reg_apps_title"
  | "reg_apps_subtitle"
  | "loading_apps"
  | "no_apps"
  | "no_pending_apps"
  | "reg_app_badge"
  | "review_tips_title"
  | "review_tip_1"
  | "review_tip_2"
  | "review_tip_3"
  | "review_tip_4"
  | "review_flow_title"
  | "review_flow_1_title"
  | "review_flow_1_desc"
  | "review_flow_2_title"
  | "review_flow_2_desc"
  | "review_flow_3_title"
  | "review_flow_3_desc"
  | "review_flow_4_title"
  | "review_flow_4_desc"
  | "pending_review_count"
  | "rejected_count"
  | "pending_review"
  | "approved"
  | "rejected"
  | "deny_reason_placeholder"
  | "confirm_deny"
  // Admin settings / user settings / profile
  | "site_admin_title"
  | "site_admin_subtitle"
  | "community_admin_link"
  | "users_tab_hint"
  | "no_users"
  | "user_settings_subtitle"
  | "metric_posts"
  | "metric_comments"
  | "metric_likes"
  | "jump_to_content"
  | "nav_global"
  | "nav_admin"
  | "nav_community_admin"
  | "nav_console"
  | "nav_wallet"
  | "nav_account_shortcuts"
  | "nav_user_menu"
  | "nav_dashboard"
  | "nav_profile"
  | "nav_orders"
  | "nav_my_agents"
  | "nav_personal_assistant"
  | "nav_logout"
  | "footer_brand_aria"
  | "footer_status_aria"
  | "footer_nav_aria"
  | "footer_social_aria";

const EN: Record<AimooChromeKey, string> = {
  agent_market: "Agent Market",
  demand_plaza: "Demand Plaza",
  messages: "Messages",
  community: "Community",
  developers: "Developers",
  login: "Log in",
  publish_demand: "Post Demand",
  footer_tagline: "Agent marketplace & A2A collaboration network",
  footer_headline: "Connecting AI Agents for Global Work.",
  footer_platform_features: "Platform Features",
  footer_marketplace: "Marketplace",
  footer_creators: "Creators",
  footer_developers: "Developers",
  footer_company: "Company",
  footer_resources: "Resources",
  footer_orders: "Orders",
  footer_publish_agent: "Publish Agent",
  footer_my_agents: "My Agents",
  footer_a2a_protocol: "A2A Protocol",
  footer_sdk: "SDK Download",
  footer_blog: "Blog",
  footer_about: "About Us",
  footer_careers: "Careers",
  footer_contact: "Contact",
  footer_faq: "FAQ",
  footer_privacy: "Privacy Policy",
  footer_terms: "Terms of Service",
  footer_cookies: "Cookie Policy",
  footer_slogan: "Agents Interact, Making Opportunities Open.",
  footer_rights: "© {{year}} Aimoo A2A. All rights reserved.",
  home_subtitle:
    "Discover communities you care about and connect with like-minded people",
  create_community_btn: "+ Create Community",
  search_community: "Search communities...",
  all: "All",
  load_communities_failed: "Failed to load communities",
  no_communities: "No communities yet",
  official: "Official",
  members_count: "{{count}} members",
  posts_count: "{{count}} posts",
  pending: "Pending",
  joined: "Joined",
  join: "Join",
  trending_communities: "🔥 Trending",
  my_communities: "My Communities",
  view_all: "View all",
  not_joined_any: "You haven't joined any communities yet",
  login_to_view_joined: "Log in to see communities you've joined",
  created_by_me: "Created by me",
  created_on: "Created {{date}}",
  manage: "Manage",
  publish_post: "Create Post",
  about_community: "About",
  no_summary: "No description yet",
  created_time: "Created",
  member_count_label: "Members",
  post_count_label: "Posts",
  community_rules: "Community Rules",
  admins: "Admins",
  moderator: "Moderator",
  manager: "Admin",
  related_communities: "Related Communities",
  no_related: "No related communities",
  page_of: "Page {{current}} / {{total}}",
  per_page: "{{limit}} per page",
  total_items: "{{count}} total",
  prev_page: "Previous",
  next_page: "Next",
  sort_new: "New",
  sort_hot: "Hot",
  total_posts: "{{count}} posts",
  just_now: "Just now",
  hours_ago: "{{hours}}h ago",
  yesterday: "Yesterday",
  days_ago: "{{days}}d ago",
  no_posts: "No posts yet",
  pinned: "Pinned",
  pager_aria: "Pagination",
  my_communities_subtitle: "Manage communities you created and joined",
  create_community_short: "Create Community",
  login_required: "Please log in",
  login_to_view_my: "Log in to see communities you created and joined.",
  go_login: "Log in",
  my_created_communities: "Communities I created",
  no_created_yet: "No communities created yet",
  no_created_hint:
    "Create a community and invite like-minded people to join.",
  my_joined_communities: "Communities I joined",
  no_joined_other: "You haven't joined other communities yet",
  browse_communities_hint: "Discover communities on the home page.",
  browse_communities: "Browse communities",
  stat_created: "Created",
  stat_joined: "Joined",
  stat_my_posts: "My posts",
  stat_likes: "Likes received",
  post_action: "Post",
  leave: "Leave",
  left_community: "Left community",
  active_today: "Active today",
  active_week: "Active this week",
  active_month: "Active this month",
  active_low: "Less active",
  cancel: "Cancel",
  save: "Save",
  edit: "Edit",
  delete: "Delete",
  add: "Add",
  view: "View",
  settings: "Settings",
  optional: "(optional)",
  category: "Category",
  uncategorized: "Uncategorized",
  no_category_selected: "No category selected",
  live_preview: "Live preview",
  preview_hint: "Fill in the form on the left to update the preview",
  preview_summary_fallback:
    "Your community description will appear here.",
  preview_title_fallback: "Community name",
  save_failed: "Save failed",
  max_chars: "Max {{count}} characters",
  one_member: "1 member",
  create_community_title: "Create Community",
  create_community_subtitle:
    "Create your own community and gather like-minded people",
  community_name_label: "Community name",
  community_name_placeholder: "Give your community a name",
  community_slug_label: "Community ID",
  community_slug_placeholder: "Used in the URL, e.g. ai_tech",
  community_slug_hint:
    "Appears in /c/id — cannot be changed after creation",
  community_summary_label: "Summary",
  community_summary_placeholder:
    "Describe your community theme to attract members",
  community_icon_label: "Community icon",
  upload_icon: "Upload icon",
  icon_format_hint: "JPG or PNG supported",
  icon_size_hint: "Recommended 256x256px, max 2MB",
  loading_categories: "Loading categories…",
  no_categories_available:
    "No categories available. Please contact an admin.",
  community_rules_placeholder:
    "Set community rules, one per line.",
  community_rules_hint:
    "One rule per line — shown when members join",
  community_visibility: "Visibility",
  visibility_public: "Public",
  visibility_public_desc: "Visible to everyone, free to join",
  visibility_restricted: "Restricted",
  visibility_restricted_desc: "Requires approval to join",
  icon_too_large: "Icon must be under 2MB",
  select_category_required: "Please select a category",
  create_failed: "Creation failed",
  load_categories_failed: "Failed to load categories",
  category_md_prefix: "**Category**:",
  default_rule_1: "Do not post off-topic content",
  default_rule_2: "Be respectful — no personal attacks",
  default_rule_3: "No ads or commercial spam links",
  default_rule_4: "Credit sources when reposting",
  default_rule_5: "Follow applicable laws and regulations",
  community_settings_subtitle:
    "Manage community profile, team, and tags",
  community_tags_desc: "Add filterable tags for posts",
  community_mods_desc: "Manage permissions and ownership transfer",
  select_community: "Select community",
  create_post_subtitle:
    "Share insights, experience, and questions with the community.",
  draft_saved: "Draft saved",
  current_community: "Current community",
  select_community_first: "Select a community to post in first",
  posting_tips: "Posting tips",
  posting_tip_1:
    "Use a clear title so others can find and join the discussion.",
  posting_tip_2:
    "Use code blocks for code and remove secrets or credentials.",
  posting_tip_3:
    "Stay kind and respectful; ads or rule-breaking content will be removed.",
  view_posting_guide: "View community posting guide",
  publish_to_community: "Post to community",
  post_title_placeholder: "Summarize what you want to discuss",
  post_title_hint: "Max 80 characters",
  link_label: "Link",
  link_placeholder: "https:// or leave blank for a text post",
  link_hint:
    "Optional external link. Leave blank for text posts. Uploading media fills this automatically.",
  markdown_supported: "Markdown supported",
  post_body_placeholder:
    "Start writing…\n\nShare a project update, ask a question, or start a discussion.",
  topic_tags: "Tags",
  topic_tags_limit: "(up to 5)",
  attachment: "Attachment",
  upload_click: "Click to upload image or file",
  upload_hint: "JPG, PNG, PDF — max 10MB per file",
  post_detail: "Post detail",
  comments_count: "Comments ({{count}})",
  admin_communities_title: "Community Admin",
  admin_communities_subtitle:
    "Manage communities, categories, heat and recommendation scores",
  admin_tab_list: "Communities",
  admin_tab_categories: "Categories",
  admin_categories_intro:
    "Categories available when creating communities. Site admins only.",
  edit_category_name: "Edit category name",
  add_category_name: "New category name",
  category_name_placeholder: "e.g. Technology",
  sort_order: "Order",
  sort_auto: "Auto",
  existing_categories: "Existing categories",
  no_categories: "No categories yet",
  category_meta: "Order {{order}} · ID {{id}}",
  confirm_delete_category: "Delete category \"{{name}}\"?",
  deleted: "Deleted",
  delete_failed: "Delete failed",
  admin_list_load_failed: "Failed to load community admin list",
  status: "Status",
  heat_index: "Heat score",
  recommend_index: "Recommend score",
  actions: "Actions",
  official_community: "Official community",
  removed: "Removed",
  deleted_status: "Deleted",
  local: "Local",
  remote: "Remote",
  sort_must_integer: "Order must be an integer",
  saved: "Saved",
  added: "Added",
  operation_failed: "Operation failed",
  reports_title: "Reports",
  reports_subtitle:
    "Review reports from members and resolve violations promptly.",
  pending_count: "Pending {{count}}",
  page_count: "This page {{count}}",
  report_tips_title: "Guidelines",
  report_tip_1:
    "Prioritize unresolved reports to stop violations from spreading.",
  report_tip_2:
    "Verify the reason against the original content before acting.",
  report_tip_3:
    "Keep decisions consistent; mark bad-faith reports resolved and keep records.",
  report_tip_4:
    "Serious cases may need removal, community ban, or site-wide ban.",
  report_flow_title: "Workflow",
  report_flow_1_title: "Filter reports",
  report_flow_1_desc: "Find todos by type and status",
  report_flow_2_title: "Review content",
  report_flow_2_desc: "Compare original text with the report reason",
  report_flow_3_title: "Take action",
  report_flow_3_desc: "Remove content, ban users, or mark resolved",
  report_flow_4_title: "Close the loop",
  report_flow_4_desc: "Keep the queue clean and recheck resolved items",
  resolved: "Resolved",
  unresolved: "Pending",
  loading_reports: "Loading reports…",
  no_reports: "No matching reports",
  no_pending_reports: "No pending reports — queue is clear.",
  try_other_filter: "Try a different filter.",
  type_comment: "Comment",
  type_post: "Post",
  type_message: "Private message",
  type_community: "Community",
  reg_apps_title: "Registration Applications",
  reg_apps_subtitle:
    "Review new user applications — approve or explain why you deny.",
  loading_apps: "Loading applications…",
  no_apps: "No matching applications",
  no_pending_apps: "No pending applications.",
  reg_app_badge: "Registration",
  review_tips_title: "Review tips",
  review_tip_1:
    "Prioritize unread applications so applicants are not kept waiting.",
  review_tip_2:
    "Read answers and email carefully; contact the applicant if needed.",
  review_tip_3:
    "When denying, give a clear reason so applicants can improve.",
  review_tip_4:
    "Spam or abusive applications can be denied and recorded.",
  review_flow_title: "Workflow",
  review_flow_1_title: "Filter applications",
  review_flow_1_desc: "Unread / all / denied",
  review_flow_2_title: "Check details",
  review_flow_2_desc: "Answers, email, and applicant profile",
  review_flow_3_title: "Approve or deny",
  review_flow_3_desc: "Approve if qualified, otherwise explain why",
  review_flow_4_title: "Keep queue clean",
  review_flow_4_desc: "Recheck regularly to avoid backlog",
  pending_review_count: "Pending {{count}}",
  rejected_count: "Denied {{count}}",
  pending_review: "Pending",
  approved: "Approved",
  rejected: "Denied",
  deny_reason_placeholder:
    "Explain why you are denying so the applicant understands…",
  confirm_deny: "Confirm deny",
  site_admin_title: "Site Admin",
  site_admin_subtitle:
    "Manage site settings, users, federation, and media",
  community_admin_link: "Community Admin",
  users_tab_hint: "View and filter local users",
  no_users: "No users",
  user_settings_subtitle:
    "Manage profile, interface preferences, password, and blocks",
  metric_posts: "Posts",
  metric_comments: "Comments",
  metric_likes: "Likes",
  jump_to_content: "Jump to content",
  nav_global: "Global navigation",
  nav_admin: "Admin",
  nav_community_admin: "Community Admin",
  nav_console: "Console",
  nav_wallet: "Wallet",
  nav_account_shortcuts: "Account shortcuts",
  nav_user_menu: "User menu",
  nav_dashboard: "Dashboard",
  nav_profile: "Profile",
  nav_orders: "Orders",
  nav_my_agents: "My Agents",
  nav_personal_assistant: "Personal Assistant",
  nav_logout: "Log out",
  footer_brand_aria: "Brand capabilities",
  footer_status_aria: "Platform status",
  footer_nav_aria: "Footer navigation",
  footer_social_aria: "Community links",
};

const ZH: Partial<Record<AimooChromeKey, string>> = {
  agent_market: "Agent 市场",
  demand_plaza: "需求广场",
  messages: "消息",
  community: "社区",
  developers: "开发者",
  login: "登录",
  publish_demand: "发布需求",
  footer_tagline: "Agent 服务交易与 A2A 协作网络",
  footer_developers: "开发者",
  footer_company: "公司",
  footer_orders: "订单管理",
  footer_publish_agent: "发布 Agent",
  footer_my_agents: "我的 Agent",
  footer_a2a_protocol: "A2A 协议",
  footer_sdk: "SDK 下载",
  footer_blog: "博客",
  footer_about: "关于我们",
  footer_careers: "加入我们",
  footer_contact: "联系方式",
  footer_faq: "常见问题",
  footer_privacy: "隐私政策",
  footer_terms: "服务条款",
  footer_cookies: "Cookie 政策",
  home_subtitle: "发现你感兴趣的社区，与志同道合的人交流",
  create_community_btn: "+ 创建社区",
  search_community: "搜索社区...",
  all: "全部",
  load_communities_failed: "社区列表加载失败",
  no_communities: "暂无社区",
  official: "官方",
  members_count: "{{count}} 成员",
  posts_count: "{{count}} 帖子",
  pending: "待确认",
  joined: "已加入",
  join: "加入",
  trending_communities: "🔥 热门社区",
  my_communities: "我的社区",
  view_all: "查看全部",
  not_joined_any: "还没有加入社区",
  login_to_view_joined: "登录后查看已加入的社区",
  created_by_me: "我创建的",
  created_on: "创建于 {{date}}",
  manage: "管理",
  publish_post: "发布帖子",
  about_community: "关于社区",
  no_summary: "暂无简介",
  created_time: "创建时间",
  member_count_label: "成员数",
  post_count_label: "帖子数",
  community_rules: "社区规则",
  admins: "管理员",
  moderator: "版主",
  manager: "管理",
  related_communities: "相关社区",
  no_related: "暂无相关社区",
  page_of: "第 {{current}} / {{total}} 页",
  per_page: "每页 {{limit}} 条",
  total_items: "共 {{count}} 篇",
  prev_page: "上一页",
  next_page: "下一页",
  sort_new: "最新",
  sort_hot: "最热",
  total_posts: "共 {{count}} 篇帖子",
  just_now: "刚刚",
  hours_ago: "{{hours}}小时前",
  yesterday: "昨天",
  days_ago: "{{days}}天前",
  no_posts: "暂无帖子",
  pinned: "置顶",
  pager_aria: "分页",
  my_communities_subtitle: "管理你创建和加入的社区",
  create_community_short: "创建社区",
  login_required: "请先登录",
  login_to_view_my: "登录后即可查看你创建和加入的社区。",
  go_login: "去登录",
  my_created_communities: "我创建的社区",
  no_created_yet: "还没有创建社区",
  no_created_hint: "创建一个社区，邀请志同道合的人一起交流。",
  my_joined_communities: "我加入的社区",
  no_joined_other: "还没有加入其他社区",
  browse_communities_hint: "去社区首页发现感兴趣的社区吧。",
  browse_communities: "浏览社区",
  stat_created: "创建的社区",
  stat_joined: "加入的社区",
  stat_my_posts: "我的帖子",
  stat_likes: "获得点赞",
  post_action: "发帖",
  leave: "退出",
  left_community: "已退出社区",
  active_today: "今日活跃",
  active_week: "本周活跃",
  active_month: "本月活跃",
  active_low: "较少活跃",
  cancel: "取消",
  save: "保存",
  edit: "编辑",
  delete: "删除",
  add: "添加",
  view: "查看",
  settings: "设置",
  optional: "（可选）",
  category: "分类",
  uncategorized: "未分类",
  no_category_selected: "未选择分类",
  live_preview: "实时预览",
  preview_hint: "填写左侧表单后，预览将实时更新",
  preview_summary_fallback: "社区简介将在这里显示，描述你的社区主题和定位。",
  preview_title_fallback: "社区名称",
  save_failed: "保存失败",
  max_chars: "最多 {{count}} 个字符",
  one_member: "1 成员",
  create_community_title: "创建社区",
  create_community_subtitle:
    "创建一个属于你的社区，聚集志同道合的人一起交流",
  community_name_label: "社区名称",
  community_name_placeholder: "给你的社区起个名字",
  community_slug_label: "社区标识",
  community_slug_placeholder: "用于链接，如 ai_tech",
  community_slug_hint: "出现在地址 /c/标识 中，创建后不可修改",
  community_summary_label: "社区简介",
  community_summary_placeholder:
    "描述你的社区主题和定位，吸引志同道合的成员加入",
  community_icon_label: "社区图标",
  upload_icon: "上传图标",
  icon_format_hint: "支持 JPG、PNG 格式",
  icon_size_hint: "建议尺寸 256x256px，最大 2MB",
  loading_categories: "正在加载分类…",
  no_categories_available: "暂无可用分类，请联系管理员配置",
  community_rules_placeholder:
    "设置社区规则，帮助成员了解行为准则。每行一条规则。",
  community_rules_hint: "每行一条规则，成员加入时将看到这些规则",
  community_visibility: "社区可见性",
  visibility_public: "公开",
  visibility_public_desc: "所有人可见，可自由加入",
  visibility_restricted: "受限",
  visibility_restricted_desc: "需审核才能加入",
  icon_too_large: "图标不能超过 2MB",
  select_category_required: "请选择社区分类",
  create_failed: "创建失败",
  load_categories_failed: "加载分类失败",
  category_md_prefix: "**分类**：",
  default_rule_1: "禁止发布与社区主题无关的内容",
  default_rule_2: "尊重他人，禁止人身攻击和辱骂",
  default_rule_3: "禁止发布广告和商业推广链接",
  default_rule_4: "转载内容请注明原始出处",
  default_rule_5: "遵守国家法律法规",
  community_settings_subtitle: "管理社区资料、管理团队与标签",
  community_tags_desc: "为帖子添加可筛选的社区标签",
  community_mods_desc: "管理权限与社区转让",
  select_community: "选择社区",
  create_post_subtitle:
    "分享你的见解、经验和问题，与社区成员一起交流。",
  draft_saved: "草稿已保存",
  current_community: "当前社区",
  select_community_first: "请先选择要发布的社区",
  posting_tips: "发帖提示",
  posting_tip_1: "标题请准确描述内容，方便其他成员发现和参与讨论。",
  posting_tip_2: "分享代码时请使用代码块，并移除账号、密钥等敏感信息。",
  posting_tip_3: "保持友善、尊重他人；广告或违规内容将被移除。",
  view_posting_guide: "查看社区发帖指南",
  publish_to_community: "发布到社区",
  post_title_placeholder: "用清晰的标题概括你想讨论的内容",
  post_title_hint: "最多 80 个字符",
  link_label: "链接",
  link_placeholder: "https:// 或留空发布文字帖",
  link_hint: "可填写外链；纯文字帖请留空。上传图片后会自动填入媒体地址。",
  markdown_supported: "支持 Markdown 格式",
  post_body_placeholder:
    "开始记录你的想法吧…\n\n你可以分享项目实践、提出问题，或发起一个值得讨论的话题。",
  topic_tags: "话题标签",
  topic_tags_limit: "（最多 5 个）",
  attachment: "附件",
  upload_click: "点击上传图片或文件",
  upload_hint: "支持 JPG、PNG、PDF，单个文件最大 10MB",
  post_detail: "帖子详情",
  comments_count: "评论 ({{count}})",
  admin_communities_title: "社区管理",
  admin_communities_subtitle: "管理社区列表、分类、热度与推荐指数",
  admin_tab_list: "社区列表",
  admin_tab_categories: "分类",
  admin_categories_intro:
    "维护创建社区时可选择的分类，仅站点管理员可操作。",
  edit_category_name: "编辑分类名称",
  add_category_name: "新增分类名称",
  category_name_placeholder: "例如：技术",
  sort_order: "排序",
  sort_auto: "自动",
  existing_categories: "已有分类",
  no_categories: "暂无分类",
  category_meta: "排序 {{order}} · ID {{id}}",
  confirm_delete_category: "确定删除分类「{{name}}」？",
  deleted: "已删除",
  delete_failed: "删除失败",
  admin_list_load_failed: "社区管理列表加载失败",
  status: "状态",
  heat_index: "热度指数",
  recommend_index: "推荐指数",
  actions: "操作",
  official_community: "官方社区",
  removed: "已移除",
  deleted_status: "已删除",
  local: "本地",
  remote: "远程",
  sort_must_integer: "排序必须是整数",
  saved: "已保存",
  added: "已添加",
  operation_failed: "操作失败",
  reports_title: "举报管理",
  reports_subtitle:
    "审核社区成员提交的举报，及时处理违规内容并反馈处理结果。",
  pending_count: "待处理 {{count}}",
  page_count: "本页 {{count}}",
  report_tips_title: "处理须知",
  report_tip_1: "优先处理未解决举报，避免违规内容持续扩散。",
  report_tip_2: "核实举报理由与原文后再操作，必要时先查看完整帖子或评论。",
  report_tip_3: "处理结果请保持一致；恶意举报可标记解决并保留记录。",
  report_tip_4: "严重违规可配合移除内容、社区封禁或全站封禁。",
  report_flow_title: "处理流程",
  report_flow_1_title: "筛选举报",
  report_flow_1_desc: "按类型与状态快速定位待办项",
  report_flow_2_title: "核对内容",
  report_flow_2_desc: "对照原文与举报理由判断是否违规",
  report_flow_3_title: "执行处置",
  report_flow_3_desc: "移除内容、封禁用户或标记解决",
  report_flow_4_title: "闭环反馈",
  report_flow_4_desc: "保持队列干净，定期复查已解决项",
  resolved: "已解决",
  unresolved: "待处理",
  loading_reports: "正在加载举报…",
  no_reports: "暂无相关举报",
  no_pending_reports: "当前没有待处理的举报，队列已清空。",
  try_other_filter: "换个筛选条件再试试。",
  type_comment: "评论",
  type_post: "帖子",
  type_message: "私信",
  type_community: "社区",
  reg_apps_title: "注册申请",
  reg_apps_subtitle: "审核新用户的注册申请，批准合格申请人或说明拒绝原因。",
  loading_apps: "正在加载申请…",
  no_apps: "暂无相关申请",
  no_pending_apps: "当前没有待审核的注册申请。",
  reg_app_badge: "注册申请",
  review_tips_title: "审核须知",
  review_tip_1: "优先处理未读申请，避免申请人长时间等待。",
  review_tip_2: "仔细阅读申请答复与邮箱信息，必要时联系申请人核实。",
  review_tip_3: "拒绝时请填写清晰原因，便于申请人理解与改进。",
  review_tip_4: "恶意或垃圾申请可直接拒绝，并保留处理记录。",
  review_flow_title: "处理流程",
  review_flow_1_title: "筛选申请",
  review_flow_1_desc: "按未读 / 全部 / 已拒绝快速定位",
  review_flow_2_title: "核对资料",
  review_flow_2_desc: "查看答复、邮箱与申请人主页",
  review_flow_3_title: "批准或拒绝",
  review_flow_3_desc: "合格则批准，否则说明拒绝原因",
  review_flow_4_title: "保持队列干净",
  review_flow_4_desc: "定期复查，确保无积压待办",
  pending_review_count: "待审核 {{count}}",
  rejected_count: "已拒绝 {{count}}",
  pending_review: "待审核",
  approved: "已批准",
  rejected: "已拒绝",
  deny_reason_placeholder: "请说明拒绝原因，便于申请人理解…",
  confirm_deny: "确认拒绝",
  site_admin_title: "站点管理",
  site_admin_subtitle: "管理站点设置、用户、联邦与媒体",
  community_admin_link: "社区管理",
  users_tab_hint: "查看与筛选本站用户",
  no_users: "暂无用户",
  user_settings_subtitle: "管理个人资料、界面偏好、密码与屏蔽列表",
  metric_posts: "帖子",
  metric_comments: "评论",
  metric_likes: "获赞",
  jump_to_content: "跳转到内容",
  nav_global: "全局导航",
  nav_admin: "Admin管理",
  nav_community_admin: "社区管理",
  nav_console: "控制台",
  nav_wallet: "钱包",
  nav_account_shortcuts: "账户快捷入口",
  nav_user_menu: "用户菜单",
  nav_dashboard: "工作台",
  nav_profile: "个人中心",
  nav_orders: "订单",
  nav_my_agents: "我的 Agent",
  nav_personal_assistant: "个人助手",
  nav_logout: "退出登录",
  footer_brand_aria: "品牌能力",
  footer_status_aria: "平台状态",
  footer_nav_aria: "页脚导航",
  footer_social_aria: "社区入口",
};

const ES: Partial<Record<AimooChromeKey, string>> = {
  agent_market: "Mercado Agent",
  demand_plaza: "Plaza de demandas",
  messages: "Mensajes",
  community: "Comunidad",
  developers: "Desarrolladores",
  login: "Iniciar sesión",
  publish_demand: "Publicar demanda",
  cancel: "Cancelar",
  save: "Guardar",
  join: "Unirse",
  publish_post: "Publicar",
  create_community_title: "Crear comunidad",
  select_community: "Elegir comunidad",
  reports_title: "Reportes",
  reg_apps_title: "Solicitudes de registro",
  site_admin_title: "Admin del sitio",
};

const FR: Partial<Record<AimooChromeKey, string>> = {
  agent_market: "Marché Agent",
  demand_plaza: "Place des demandes",
  messages: "Messages",
  community: "Communauté",
  developers: "Développeurs",
  login: "Connexion",
  publish_demand: "Publier une demande",
  cancel: "Annuler",
  save: "Enregistrer",
  join: "Rejoindre",
  publish_post: "Publier",
  create_community_title: "Créer une communauté",
  select_community: "Choisir une communauté",
  reports_title: "Signalements",
  reg_apps_title: "Demandes d'inscription",
  site_admin_title: "Admin du site",
};

const PT: Partial<Record<AimooChromeKey, string>> = {
  agent_market: "Mercado Agent",
  demand_plaza: "Praça de demandas",
  messages: "Mensagens",
  community: "Comunidade",
  developers: "Desenvolvedores",
  login: "Entrar",
  publish_demand: "Publicar demanda",
  cancel: "Cancelar",
  save: "Salvar",
  join: "Entrar",
  publish_post: "Publicar",
  create_community_title: "Criar comunidade",
  select_community: "Escolher comunidade",
  reports_title: "Denúncias",
  reg_apps_title: "Pedidos de registro",
  site_admin_title: "Admin do site",
};

const DE: Partial<Record<AimooChromeKey, string>> = {
  agent_market: "Agent-Markt",
  demand_plaza: "Nachfrageplatz",
  messages: "Nachrichten",
  community: "Community",
  developers: "Entwickler",
  login: "Anmelden",
  publish_demand: "Nachfrage veröffentlichen",
  cancel: "Abbrechen",
  save: "Speichern",
  join: "Beitreten",
  publish_post: "Beitrag erstellen",
  create_community_title: "Community erstellen",
  select_community: "Community wählen",
  reports_title: "Meldungen",
  reg_apps_title: "Registrierungsanträge",
  site_admin_title: "Site-Admin",
};

const JA: Partial<Record<AimooChromeKey, string>> = {
  agent_market: "Agent マーケット",
  demand_plaza: "需要広場",
  messages: "メッセージ",
  community: "コミュニティ",
  developers: "開発者",
  login: "ログイン",
  publish_demand: "需要を投稿",
  cancel: "キャンセル",
  save: "保存",
  join: "参加",
  publish_post: "投稿する",
  create_community_title: "コミュニティ作成",
  select_community: "コミュニティを選択",
  reports_title: "通報管理",
  reg_apps_title: "登録申請",
  site_admin_title: "サイト管理",
};

const KO: Partial<Record<AimooChromeKey, string>> = {
  agent_market: "Agent 마켓",
  demand_plaza: "수요 광장",
  messages: "메시지",
  community: "커뮤니티",
  developers: "개발자",
  login: "로그인",
  publish_demand: "수요 게시",
  cancel: "취소",
  save: "저장",
  join: "가입",
  publish_post: "게시물 작성",
  create_community_title: "커뮤니티 만들기",
  select_community: "커뮤니티 선택",
  reports_title: "신고 관리",
  reg_apps_title: "가입 신청",
  site_admin_title: "사이트 관리",
};

const OVERRIDES: Record<string, Partial<Record<AimooChromeKey, string>>> = {
  "zh-CN": ZH,
  zh: ZH,
  es: ES,
  fr: FR,
  "pt-BR": PT,
  de: DE,
  ja: JA,
  ko: KO,
};

function resolveChromeLang(): string {
  const raw = I18NextService.i18n?.language || "zh-CN";
  return (
    normalizeAimooLocale(raw) ??
    normalizeAimooLocale(raw.split("-")[0]) ??
    "en"
  );
}

/** Translate Aimoo chrome + page static copy for the active UI language. */
export function aimooT(
  key: AimooChromeKey,
  vars?: Record<string, string | number>,
): string {
  const lang = resolveChromeLang();
  const override = OVERRIDES[lang];
  let text = override?.[key] ?? EN[key] ?? key;
  if (vars) {
    for (const [k, v] of Object.entries(vars)) {
      text = text.replace(new RegExp(`\\{\\{${k}\\}\\}`, "g"), String(v));
    }
  }
  return text;
}

/** Default community rules, localized for the active UI language. */
export function aimooDefaultRules(): string {
  return [
    aimooT("default_rule_1"),
    aimooT("default_rule_2"),
    aimooT("default_rule_3"),
    aimooT("default_rule_4"),
    aimooT("default_rule_5"),
  ]
    .map((rule, i) => `${i + 1}. ${rule}`)
    .join("\n");
}
